import { combineReducers } from 'redux'

import * as actions from './actions'
import config from '../../config/index';

const initialUnderwriterList = () => {
    return [config.defaultContactUnderWriter];
}

const createReducer = (initialState, handlers) => (state = initialState, action) => (handlers.hasOwnProperty(action.type) ? handlers[action.type](state, action) : state)

export const isLoading = createReducer(true, {
    [actions.SET_LOADING]: (_, action) => action.payload
})

export const isAuthenticated = createReducer(false, {
    [actions.SET_AUTHENTICATED]: (_, action) => action.payload,
    [actions.UNSET_AUTH]: () => false,
})

export const user = createReducer(null, {
    [actions.SET_USER]: (_, action) => action.payload,
    [actions.UNSET_AUTH]: () => null,
})

export const contactUnderWriter = createReducer(initialUnderwriterList(), {
    [actions.SET_CONTACT_UNDERWRITER]: (_, action) => {
        return action.payload || []
    },
    [actions.RESET_CONTACT_UNDERWRITER]: (_, action) => {
        return initialUnderwriterList()
    }
})

export const reducers = combineReducers({ isLoading, isAuthenticated, user, contactUnderWriter })
